module.exports = __webpack_public_path__ + "static/media/qualidade-impressao-250.b54f700e.jpg";